/**
 * 特有法会、相似法会
 * 
 */
export const record = {225:[225,322,340,372],230:[230,326,346,394,378],238:[238,355,387],243:[243,361],245:[245,370,390],249:[249,333,368,400],309:[309,336,366,398],311:[311,345,347,401,377],312:[312,354,386],313:[313,360,393],315:[315,367,397],297:[297],361:[243,361]}